export const secondsToTime = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds < 10 ? `0${seconds}`: seconds}`
}